@if (('dashboard.brand' | transloco) + ' Logo'; as brandAlt) {
  <a routerLink="/">
    <img class="full" [src]="lgRenownedLogoPath | staticImageUrl" [alt]="brandAlt" />
    <img class="mini" [src]="smRenownedLogoPath | staticImageUrl" [alt]="brandAlt" />
  </a>
}
